export interface SignInCredentials {
  email: string;
  password: string;
}

export type SignInErrors = Partial<Record<keyof SignInCredentials, string>>;

export const SIGN_IN_MESSAGES = {
  emailRequired: 'Enter your email address',
  emailInvalid: 'Enter a valid email address, like name@example.com',
  passwordRequired: 'Enter your password',
} as const;

/** RFC 5321 caps an address at 254 characters. */
const MAX_EMAIL_LENGTH = 254;

/** Something@something.tld, with no spaces and no empty labels in the domain. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

export const validateEmail = (value: string): string | undefined => {
  const email = value.trim();
  if (!email) return SIGN_IN_MESSAGES.emailRequired;
  if (email.length > MAX_EMAIL_LENGTH || !EMAIL_PATTERN.test(email)) return SIGN_IN_MESSAGES.emailInvalid;
  return undefined;
};

/** Sign-in only checks that a password was given; strength rules belong to registration. */
export const validatePassword = (value: string): string | undefined =>
  value ? undefined : SIGN_IN_MESSAGES.passwordRequired;

export const validateSignIn = ({ email, password }: SignInCredentials): SignInErrors => {
  const errors: SignInErrors = {};
  const emailError = validateEmail(email);
  const passwordError = validatePassword(password);
  if (emailError) errors.email = emailError;
  if (passwordError) errors.password = passwordError;
  return errors;
};
